import {createSlice} from '@reduxjs/toolkit';
import {RootState} from './Store';
import {PowerBiReport} from '../types/powerbiReportTypes';

const PowerBiSlice = createSlice({
  name: 'powerBiSlice',
  initialState: {
    accessToken: null,
    loading: false,
    error: null,
    pageName: null,
    reportId: '',
    datasetId: '',
    pageId: '',
    aadTokenExpiry: null,
    selectedReportCategoryName: null,
    selectedReport: {} as PowerBiReport,
  },
  reducers: {
    clearAadToken: (state) => {
      state.accessToken = null;
      state.loading = false;
      state.error = null;
      state.pageName = null;
      state.reportId = '';
      state.datasetId = '';
      state.pageId = '';
      state.aadTokenExpiry = null;
      state.selectedReportCategoryName = null;
      state.selectedReport = {} as PowerBiReport;
    },
    setPageName: (state, action) => {
      state.pageName = action.payload;
    },
    setDatasetId: (state, action) => {
      state.datasetId = action.payload;
    },
    setReportId: (state, action) => {
      state.reportId = action.payload;
    },
    setPageId: (state, action) => {
      state.pageId = action.payload;
    },
    setAadToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setAadTokenExpiry: (state, action) => {
      state.aadTokenExpiry = action.payload;
    },
    setSelectedReportCategoryName: (state, action) => {
      state.selectedReportCategoryName = action.payload;
    },
    setSelectedReport: (state, action) => {
      state.selectedReport = action.payload;
    },
    clearPowerBiStore: (state) => {
      state.accessToken = null;
      state.loading = false;
      state.error = null;
      state.pageName = null;
      state.reportId = '';
      state.datasetId = '';
      state.pageId = '';
      state.aadTokenExpiry = null;
      state.selectedReportCategoryName = null;
      state.selectedReport = {} as PowerBiReport;
    },
  },
});

export const {
  clearAadToken,
  setPageName,
  setAadToken,
  setDatasetId,
  setReportId,
  setPageId,
  clearPowerBiStore,
  setAadTokenExpiry,
  setSelectedReportCategoryName,
  setSelectedReport,
} = PowerBiSlice.actions;
export const getPageName = (state: RootState) => state.powerBiSlice.pageName;
export const getReportId = (state: RootState) => state.powerBiSlice.reportId;
export const getDatasetId = (state: RootState) => state.powerBiSlice.datasetId;
export const getPageId = (state: RootState) => state.powerBiSlice.pageId;
export const getAadTokenValue = (state: RootState) =>
  state.powerBiSlice.accessToken;
export const getAadTokenExpiry = (state: RootState) =>
  state.powerBiSlice.aadTokenExpiry;
export const getSelectedReportCategoryName = (state: RootState) =>
  state.powerBiSlice.selectedReportCategoryName;
export const getSelectedReport = (state: RootState) =>
  state.powerBiSlice.selectedReport;

export default PowerBiSlice.reducer;
